/*
	its frontend

	Omni-usable helper functions

    @file         minions.js
    @author       Robert Fischer, fischer@tForge.eu
    @date         05/2022
    @copyright    tForge

*/

import { domain } from './config';


export const URL_API = (command) => {
    return domain + "be/" + command;
};//URL_API()


export const URL_IMG = (imageName) => {
    return domain + "imgdata/" + imageName + "?" + (new Date()).getTime();
};//URL_IMG()


// ================================ js tools =================================


export const deepCopyObject = obj => {
    return JSON.parse(JSON.stringify(obj));
};//deepCopyObject()

export const stopClickPropagation = evt => {
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();
    return false;
};//stopClickPropagation()




// ========================= (cache) software version ========================


export const readVersion = async ()=> {
    const keyList = await caches.keys()
        .catch(err=>{
            return '0.0.0';
        });
    if(keyList) {
        return keyList[0];
    }
    return '0.0.0';
};//readVersion()


// ================================ ? =================================
